import { Forms } from 'sites/types';
import { FormFieldConfig } from 'ui/forms/custom/types';

import { commonForms } from '../common/forms';

const addressForm: Array<Array<FormFieldConfig>> = [
  [
    { name: 'firstName', type: 'input', required: true },
    { name: 'lastName', type: 'input', required: true },
  ],
  [{ name: 'companyName', type: 'input', required: false }],
  [
    { name: 'address1', type: 'input', required: true },
    { name: 'streetNumber', type: 'google-address-look-up', required: true },
  ],
  [{ name: 'address2', type: 'input' }],
  [
    { name: 'city', type: 'input', required: true },
    { name: 'postalCode', type: 'input', required: true },
  ],
  [{ name: 'countryCode', type: 'dropdown', required: true }],
];
export const BGForms: Forms = {
  ...commonForms,
  accountAddress: [
    [{ name: 'title', type: 'input', required: true }],
    ...addressForm,
    [{ name: 'phone', type: 'input', inputType: 'tel' }],
    [{ name: 'preferred', type: 'checkbox' }],
  ],
  checkoutAddress: [...addressForm],
  checkoutContactInfo: [
    [
      { name: 'email', type: 'input', inputType: 'email', required: true },
      { name: 'phone', type: 'input', inputType: 'tel' },
    ],
    [{ name: 'emailList', type: 'checkbox' }],
  ],
  checkoutContactInfoNoSubscription: [
    [
      { name: 'email', type: 'input', inputType: 'email', required: true },
      { name: 'phone', type: 'input', inputType: 'tel' },
    ],
  ],
  createAccountInConfirmation: [
    [{ name: 'password', type: 'password', required: true }],
    [{ name: 'passwordConfirmation', type: 'password', required: true }],
    [
      { name: 'register', type: 'button', buttonType: 'submit' },
      { name: 'blank', type: 'blank' },
    ],
  ],
  editProfile: [
    [{ name: 'firstName', type: 'input', required: true }],
    [{ name: 'lastName', type: 'input', required: true }],
    [
      {
        name: 'save',
        type: 'button',
        buttonType: 'submit',
      },
    ],
  ],
  changePassword: [
    [{ name: 'currentPassword', type: 'password', required: true }],
    [{ name: 'newPassword', type: 'password', required: true }],
    [{ name: 'newPasswordConfirmation', type: 'password', required: true }],
    [
      {
        name: 'save',
        type: 'button',
        buttonType: 'submit',
      },
    ],
  ],
  resetPassword: [
    [{ name: 'newResetPassword', type: 'password', required: true }],
    [
      {
        name: 'newResetPasswordConfirmation',
        type: 'password',
        required: true,
      },
    ],
    [
      {
        name: 'save',
        type: 'button',
        buttonType: 'submit',
      },
      {
        name: 'cancelLink',
        type: 'link',
      },
    ],
  ],
};
